import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-empresa',
  templateUrl: './alert-empresa.component.html',
  styleUrls: ['./alert-empresa.component.scss']
})
export class AlertEmpresaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
